export default __webpack_public_path__ + "static/media/img_10.c67dccc3.png";